<template>
  <page-view title="调研服务费管理">
    <a-card>
      <a-row class="mb-5">
        <a-col :span="24">
          <a-form layout="inline">
            <a-form-item>
              <a-input v-model="queryParam.queryKey"
                       style="width: 600px;"
                       placeholder="请输入采购人名称/项目名称/项目编号"
              ></a-input>
            </a-form-item>
            <a-form-item label="到账时间">
              <a-range-picker :placeholder="['开始时间', '结束时间']" v-model="dzTimeArr"
                              format="YYYY-MM-DD" class="w-100" @change="onChangeDateJn"/>
            </a-form-item>
            <a-form-item>
              <a-button type="primary" icon="search" @click="onSearch">查询</a-button>
              <a-button class="ml-3" @click="reset">重置</a-button>
            </a-form-item>
            <br>
            <br>
            <a-form-item style="float: left">
              <a-radio-group
                  v-model="queryParam.invoiceFlag"
                  @change="e=> radioSearch(e.target.value, 'invoiceFlag')">
                <a-radio-button value="0">
                  未开票
                </a-radio-button>
                <a-radio-button value="1">
                  开票
                </a-radio-button>
                <a-radio-button value="">
                  全部
                </a-radio-button>
              </a-radio-group>
            </a-form-item>
            <a-form-item style="float: right">
              <a-radio-group
                  v-model="queryParam.creditedFlag"
                  @change="e=> radioSearch(e.target.value, 'creditedFlag')">
                <a-radio-button value="0">
                  未到账
                </a-radio-button>
                <a-radio-button value="1">
                  已到账
                </a-radio-button>
                <a-radio-button value="">
                  全部
                </a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-form>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <s-table
              ref="table"
              :columns="columns"
              :data="loadData"
              :pagination="{ showTotal: total => `总共 ${total} 条` }"
              :rowKey="record => record.id"
              class="border"
              size="middle"
          >
            <div :title="record.projectName" @click="onViewOpen(record)"
                 :style="{whiteSpace: 'nowrap',textOverflow: 'ellipsis',overflow: 'hidden', wordWrap: 'break-word', wordBreak: 'break-all' }"
                 slot="projectName"
                 slot-scope="record"
            >
              <a>
                {{ record.projectName }}<br>
                {{ record.projectCode || record.projectOutCode }} </a><br>
            </div>
            <template slot="wtrlxr" slot-scope="record"
            >
              {{ record.wtrlxr }}<br>
              {{ record.wtrlxrdh }}
            </template>
            <template slot="operate" slot-scope="record">
              <a-popconfirm v-if="record.creditedFlag === '1'" title="是否确认?" placement="top" ok-text="确认未到账"
                            cancel-text="取消" @confirm="onEditFlag(record,'0')">
                <a-icon slot="icon" type="question-circle-o" style="color: red"/>
                <a style="color: red">已到账
                </a>
              </a-popconfirm>
              <a v-else @click="onOpenModel(record,'0')">确认到账</a>
              <a-divider type="vertical"/>
              <a-popconfirm placement="topRight" v-if="record.invoiceFlag === '1'"
                            ok-text="确认未开票" cancel-text="取消"
                            @confirm="onEditFlag(record,'1')">
                <a-icon slot="icon" type="question-circle-o" style="color: red"/>
                <template slot="title">
                  <p>采购人名称：{{ record.wtrdwmc }}</p>
                  <p>信用代码（税号）：{{ record.wtrtyxydm }}</p>
                  <p>地址：{{ record.wtrdwdz }}</p>
                  <p>电话号码：{{ record.wtrbgdh }}</p>
                  <p>开户银行：{{ record.bank }}</p>
                  <p>银行账号：{{ record.bankAccount }}</p>
                  <p>开票时间：{{ record.invoiceDate|dayjs('YYYY-MM-DD') }}</p>
                  <p>开票类型：{{ record.invoiceTypeText }}</p>
                </template>
                <a style="color: red"
                >已开发票</a>
              </a-popconfirm>
              <a v-else @click="onOpenModel(record,'1')">未开发票</a>
            </template>
          </s-table>
        </a-col>
      </a-row>
      <div class="mt-5" style="text-align: left;"><B> &nbsp;总金额统计: <span
          style="color: red;"> {{ totalMoney }} </span>元</B></div>
    </a-card>
    <survey-dz-and-fwf-model ref="surveyDzRef" @cancel="surveyDzVisible = false"
                             @success="surveyDzSuccess" :visible="surveyDzVisible"/>
    <survey-bid-model-view ref="surveyBidRef"/>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import STable from '@/components/Table'
import moment from 'moment'
import { QueryPage, UpdateBidXqdcFwf } from '@/views/demandsurveybid/servicefee/api/FeeRequest'
import SurveyDzAndFwfModel from '@/views/demandsurveybid/servicefee/SurveyDzAndFwfModel.vue'
import SurveyBidModelView from '@/views/demandsurveybid/surveybid/SurveyBidModelView.vue'

export default {
  name: 'SurveyServiceFeeList',
  components: {
    SurveyBidModelView,
    SurveyDzAndFwfModel,
    PageView,
    STable,
    moment,
  },
  data () {
    return {
      totalMoney: 0,
      queryParam: {
        queryKey: undefined,
        creditedStartDate: undefined,
        creditedEndDate: undefined,
        creditedFlag: '',
        invoiceFlag: '',
      },
      columns: [
        {
          title: '采购人名称',
          width: '18%',
          dataIndex: 'wtrdwmc',
        },
        {
          title: '项目名称',
          align: 'left',
          scopedSlots: { customRender: 'projectName' }
        },
        {
          title: '联系人',
          width: '15%',
          align: 'center',
          scopedSlots: { customRender: 'wtrlxr' }
        },
        {
          title: '服务费',
          width: '15%',
          dataIndex: 'serviceFee',
          ellipsis: true,
          customRender: (val) => {
            return `${val}元`
          }
        },
        {
          title: '到账时间',
          width: '10%',
          dataIndex: 'creditedDate',
          align: 'center',
          customRender: (val) => {
            return val && moment(val).format('YYYY-MM-DD')
          },
        },
        {
          title: '操作',
          width: '15%',
          align: 'center',
          scopedSlots: { customRender: 'operate' }
        }
      ],
      loadData: async (parameter) => {
        const data = {
          ...parameter,
          ...this.queryParam
        }
        let res = await QueryPage(data)
        this.totalMoney = res.totalMoney
        return res
      },
      dzTimeArr: [],
      surveyDzVisible: false
    }
  },
  methods: {
    onChangeDateJn (date, dateString) {
      this['dzTimeArr'] = date
      this.queryParam['creditedStartDate'] = dateString[0]
      this.queryParam['creditedEndDate'] = dateString[1]
      this.onSearch()
    },
    onOpenModel (record, type) {
      this.surveyDzVisible = true
      this.$refs.surveyDzRef.initData(record, type)
    },
    surveyDzSuccess(){
      this.surveyDzVisible = false
      this.$refs.table.refresh()
    },
    async onEditFlag (record, type) {
      try {
        const data = {
          id: record.id,
          submitType: type
        }
        //是到账类型
        if (type === '0') {
          data.creditedFlag = '0'
        } else {
          data.invoiceFlag = '0'
        }
        let res = await UpdateBidXqdcFwf(data)
        if (res.code === 200) {
          this.$message.success('操作成功')
          this.$refs.table.refresh()
        } else {
          this.$message.error('操作失败')
        }
      } catch (e) {
        this.$message.error('操作失败')
      } finally {
      }
    },
    radioSearch (value, type) {
      this.queryParam[type] = value || ''
      this.onSearch()
    },
    reset () {
      this.queryParam = {
        queryKey: undefined,
        creditedStartDate: undefined,
        creditedEndDate: undefined,
        creditedFlag: '',
        invoiceFlag: '',
      }
      this.dzTimeArr = []
      this.onSearch()
    },
    onSearch () {
      this.$refs.table.refresh(true)
    },
    onViewOpen (record) {
      this.$refs.surveyBidRef.loadData(record.projectId)
    },
  },
}
</script>

<style scoped>
/deep/ .page-header .detail .main .extra {
  margin-left: 0;
}
</style>
